import IConfirmarEnvioDocumentosOnboardingRequest from '../entities/IConfirmarEnvioDocumentosOnboardingRequest'
import { IPagamentoRepository } from '../repositories/IPagamentoRepository'

export interface IConfirmarEnvioDocumentosOnboarding {
  execute(data: IConfirmarEnvioDocumentosOnboardingRequest): Promise<void>
}

export default class ConfirmarEnvioDocumentosOnboardingImpl
  implements IConfirmarEnvioDocumentosOnboarding
{
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(
    data: IConfirmarEnvioDocumentosOnboardingRequest,
  ): Promise<void> {
    return this.pagamentosRepository.confirmarEnvioDocumentosOnboarding(data)
  }
}
